import APIService from '@/api'

export default class APITransmissionType extends APIService{

    constructor(){
        super('transmissiontypes')
    }

    getAll() {
        var response = this.AxiosInstance
            .get(this.ApiUrl)
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }
}


// WEBPACK FOOTER //
// ./src/api/transmissiontype.js